'use strict';
var novicell = novicell || {};

novicell.forgot_password = novicell.forgot_password || function () {
    var isProccessing = false;

    function init() {
        var forgotForm = document.getElementById("lostpasswordform");
        if (forgotForm != null) {
            forgotForm.onsubmit = function (e) {
                if (!isProccessing) {
                    var form = new FormData(e.target);
                    var email = form.get('user_login');
                    var return_url = form.get('return_url');
                    if (email != "" && validateEmail(email)) {
                        isProccessing = true;
                        var action = "retrieve_new_password";
                        retrieve_password_request(action, email, return_url);
                        document.getElementById("errorMessage").classList.add('hide-message');
                    } else {
                        document.getElementById("errorMessage").innerHTML = 'Email is invalid';
                        document.getElementById("errorMessage").classList.remove('hide-message');
                    }
                }
                return false;
            }
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function retrieve_password_request(action, email, return_url) {

        var request = new XMLHttpRequest(),
            method = 'POST',
            url = '/api-nh-user-retrieve-pass.php';

        request.open(method, url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.setRequestHeader('Token', 'yoiNQeYIaRAWswllfz2hk87tN65gASIl6tKbAQbDdNN7rdoHAR3FfTWGv3wsRmkB');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                var result = JSON.parse(this.response);
                if (result.status) {
                    window.location.href = result.return_url;
                } else {
                    if (result.message != "Fail") {
                        document.getElementById("errorMessage").innerHTML = result.message;
                        document.getElementById("errorMessage").classList.remove('hide-message');
                    }
                }
            }
            else{
                document.getElementById("errorMessage").innerHTML = "Har et problem med at hente adgangskoden. Prøv det senere.";
                document.getElementById("errorMessage").classList.remove('hide-message');
            }

            isProccessing = false;
        }

        request.onerror = function () {
            document.getElementById("errorMessage").innerHTML = "Har et problem med at hente adgangskoden. Prøv det senere.";
            document.getElementById("errorMessage").classList.remove('hide-message');
        };

        request.send('action=' + action +
            '&email=' + email +
            '&return_url=' + return_url
        );

    }

    function logInfo(event, message) {
        var request = new XMLHttpRequest(),
            method = 'POST',
            url = ajaxurl;

        request.open(method, url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');

        request.onload = function () {

        }

        request.send('action=log_info' +
            '&event=' + event +
            '&message=' + message
        );
    }

    return {
        init: init
    };
}();


